<!--工单模板管理-->
<template>
	<div>
		<el-row justify=center>
			<el-col :span="1" v-for="project in dataList" :key="project.pid" :offset="0" style="width:25%; margin-top:30px;">
				<el-card @click="addOutMac" :body-style="{ padding: '0px'}" shadow="hover" style="width: 260px;height: 320px;">
					<div style="padding: 6px;height: 220px;">
						<div style="margin-top: 35px;text-align: center; font-size:20px;font-weight:bold;">{{project.name}}</div>
						<div style="margin: 35px; font-size:18px;">
							外机：{{project.twoVirtualDeviceNames[0]}}
						</div>
						<div style="margin: 35px; font-size:18px;">
							内机：{{project.oneVirtualDeviceNames.length}}个内机设备
						</div>
						<div style="margin: 35px; display:none;">
							<div v-for="i in project.oneVirtualDeviceNames" :key="i" style="text-align: left;"><font size="5">内机：{{i}}</font></div>
						</div>
					</div>
					<div>
						<center>
							<el-button @click="delOutMac(project.id)" icon="el-icon-delete">删除</el-button>
							<el-button @click="editOutMac(project)" icon="el-icon-edit">修改</el-button>
						</center>
					</div>
				</el-card>
			</el-col>
			<el-col :span="1" :offset="0" style="width:25%; margin-top:30px;">
				<el-card @click="addOutMac" :body-style="{ padding: '0px', height:'360px'}" shadow="hover" style="width: 260px;height: 320px;">
					<div style="padding: 6px;height: 120px;">
						<div style="margin-top: 35px;text-align: center;"></div>
					</div>
					<div>
						<center>
						<el-button @click="addOutMac" icon="el-icon-plus">新增</el-button>
						</center>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<addOutMacDialog @addItemSuccess="addItemSuccess" ref='addOutMacDialog'></addOutMacDialog>
	</div>
</template>

<script>
	import addOutMacDialog from '@/page/projectDingZhi/tiancheng/dialogs/addOutMacDialog.vue'
	export default {
		components: {
			addOutMacDialog,
		},
		props: {},
		data() {
			return {
				dataList:[],
			}
		},
		created() {
		},
		mounted() {
			this.search();
		},
		destroyed() {},
		computed: {
		},
		watch: {
		},
		methods: {
			clickItem(pn){
				alert(pn);
			},
			addOutMac() {
				this.$refs.addOutMacDialog.itemId = '';
				this.$refs.addOutMacDialog.itemName = '';
				this.$refs.addOutMacDialog.setLeftDefualtDevices([]);
				this.$refs.addOutMacDialog.addTemplateShow=true
			},
			editOutMac(item) {
				this.$refs.addOutMacDialog.itemId = item.id;
				this.$refs.addOutMacDialog.itemName = item.name;
				this.$refs.addOutMacDialog.addTemplateShow=true
			},
			search() {
				this.getTemplateList()
			},
			delOutMac(id){
				this.$confirm('确认删除分摊项目?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.tcFentanApi.delDivideItem(id, respon => {
						this.search();
					})
				}).catch(() => {      
				});
			},
			getTemplateList() {
				this.$api.tcFentanApi.divideItemList(1, respon => {
					for(var i=0; i<respon.length; i++){
						respon[i].oneDeviceNos = JSON.parse(respon[i].oneDeviceNos);
						if(respon[i].twoDeviceNos != null){
							respon[i].twoDeviceNos = JSON.parse(respon[i].twoDeviceNos);
						}
					}
				 	this.total = respon.length;
					this.dataList = respon;
				})
			},
			addItemSuccess(){
				this.search();
			}
		}
	}
</script>